module.exports = __webpack_public_path__ + "img/IMG_1156_L_BlackMatted.2b703f3b.jpg";